import styled from '@emotion/styled';
import React from 'react';
import Link from 'next/link';
import { fontFrame } from '../../../../styles/mixin/font';
import { BLACK, LIGHT_BLUE } from '../../../../styles/constants/color';
import { BODY_WIDTH } from '../../../../styles/constants/size';
import Span from '../../text/Span';

const Dl = styled.dl`
  display: flex;
  width: 100%;
  max-width: ${BODY_WIDTH};
  height: auto;
  margin: 0 auto;
  padding: 40px 20px;
`;

const ItemDiv = styled.div`
  width: 25%;
  height: 100%;
`;

const Dt = styled.dt`
  width: auto;
  height: auto;
  text-align: center;
  margin-bottom: 20px;
`;

const Dd = styled.dd`
  display: grid;
  place-items: center;
  width: auto;
  height: 40px;
`;

const H1 = styled.h1<{ active: boolean }>`
  display: inline-block;
  width: auto;
  height: 40px;
  ${fontFrame('500', '22px', '1', LIGHT_BLUE)}
  border-bottom: ${props => props.active && `2px solid ${LIGHT_BLUE}`};
`;

const Button = styled.button`
  width: auto;
  height: auto;
  text-align: center;
`;

interface Props {
  groupNameList: any[];
  itemList: any[];
  openVideo: () => void;
  openCalculator: () => void;
  closeEvent: () => void;
}

/**
 *  pc화면에서의 네비게이션 목록 컴포넌트
 * @param {any[]} groupNameList 네비게이션 대제목 목록
 * @param {any[]} itemList 네비게이션 목록
 * @param {function} openVideo 비디오 열기 함수
 * @param {function} openCalculator 할부계산기 열기 함수
 * @param {function} closeEvent 네비게이션 비활성화 클릭 함수
 *  */
function NavigationBodyContents({
  groupNameList,
  itemList,
  openVideo,
  openCalculator,
  closeEvent,
}: Props): JSX.Element {
  return (
    <Dl>
      {groupNameList.map((group: GroupName) => (
        <ItemDiv key={group.name}>
          <Dt>
            <H1 active={group.active}>{group.name}</H1>
          </Dt>
          {itemList
            .filter((item: Item) => item.group === group.name)
            .map((item: Item) => (
              <Dd key={item.name}>
                {item.href && (
                  <Link href={item.href} onClick={closeEvent} passHref>
                    <Span fontSize='15px' color={item.active ? LIGHT_BLUE : BLACK}>
                      {item.name}
                    </Span>
                  </Link>
                )}
                {item.action && (
                  <Button
                    onClick={() => {
                      item.action === 'calculator' ? openCalculator() : openVideo();
                    }}
                  >
                    <Span fontSize='15px' color={item.active ? LIGHT_BLUE : BLACK}>
                      {item.name}
                    </Span>
                  </Button>
                )}
              </Dd>
            ))}
        </ItemDiv>
      ))}
    </Dl>
  );
}

interface GroupName {
  name: string;
  active: boolean;
}

interface Item {
  name: string;
  group: string;
  href?: string;
  action?: string;
  active: boolean;
}

export default NavigationBodyContents;
